import React from 'react';

import { Guest } from 'types/checkin';

import * as Styled from './styled';

interface AccordionTitleProps {
  person: Partial<Omit<Guest, 'id'>>;
  isActive?: boolean;
  isPrimary?: boolean;
  'data-testid'?: string;
}

const getIconFillColor = ({
  isPrimary,
  isActive
}: Pick<AccordionTitleProps, 'isActive' | 'isPrimary'>) => {
  if (isActive) {
    return Styled.activeColor;
  } else if (isPrimary) {
    return Styled.primaryColor;
  } else {
    return undefined;
  }
};

const AccordionTitle: React.FC<AccordionTitleProps> = ({
  person,
  isActive,
  isPrimary,
  'data-testid': dataTestId
}) => {
  return (
    <Styled.Container>
      <Styled.Icon fill={getIconFillColor({ isActive, isPrimary })} />
      <Styled.Details>
        {person.isNew ? (
          <Styled.Heading isActive={isActive} data-testid={'AccordionAddAnother'}>
            Add another
          </Styled.Heading>
        ) : (
          <>
            <Styled.Heading isActive={isActive} data-testid={`${dataTestId}Name`}>
              {person.firstName} {person.lastName}
            </Styled.Heading>
            <Styled.BodyText isActive={isActive} data-testid={`${dataTestId}ContactNumber`}>
              {person.contactNumber}
            </Styled.BodyText>
          </>
        )}
      </Styled.Details>
    </Styled.Container>
  );
};

export default AccordionTitle;
